class GalleryZoom extends HTMLElement {
  connectedCallback() {
    // Desktop-only: skip touch so native pinch-zoom is preserved.
    const canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (!canHover) return;

    const selector = this.getAttribute("zoom-target") || "[data-layers-container]";
    this.target = this.querySelector(selector);
    if (!this.target) return;

    this.scale = parseFloat(this.getAttribute("zoom-scale")) || 2;
    this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    this.handleMove = this.handleMove.bind(this);
    this.handleLeave = this.handleLeave.bind(this);

    // GSAP is loaded after this element upgrades, so read it lazily at
    // event time rather than requiring it here.
    this.addEventListener("pointermove", this.handleMove);
    this.addEventListener("pointerleave", this.handleLeave);
  }

  disconnectedCallback() {
    this.removeEventListener("pointermove", this.handleMove);
    this.removeEventListener("pointerleave", this.handleLeave);
    if (window.gsap && this.target) gsap.killTweensOf(this.target);
  }

  handleMove(event) {
    if (!window.gsap) return;

    const bounds = this.getBoundingClientRect();
    const xPercent = ((event.clientX - bounds.left) / bounds.width) * 100;
    const yPercent = ((event.clientY - bounds.top) / bounds.height) * 100;

    gsap.to(this.target, {
      xPercent: -(xPercent - 50),
      yPercent: -(yPercent - 50),
      scale: this.scale,
      duration: this.reduceMotion ? 0 : 0.5,
      ease: "power2.out",
    });
  }

  handleLeave() {
    if (!window.gsap) return;

    gsap.to(this.target, {
      xPercent: 0,
      yPercent: 0,
      scale: 1,
      duration: this.reduceMotion ? 0 : 0.5,
      ease: "power2.out",
    });
  }
}

customElements.define("gallery-zoom", GalleryZoom);
